export const DISTANCE_UNIT_MILE = 'mile';
export const DISTANCE_UNIT_KILOMETER = 'kilometer';
export const MILE_TO_KILOMETER = 1.609344;

export function miToKm(distanceMi: number, round: boolean = true) {
  const distanceKm = distanceMi * MILE_TO_KILOMETER;
  return round ? Math.round(distanceKm) : distanceKm;
}
export function kmToMi(kilometers: number, round: boolean = true) {
  const distanceKm = kilometers / MILE_TO_KILOMETER;
  return round ? Math.round(distanceKm) : distanceKm;
}

export function getMiles(distanceUnit, value) {
  return distanceUnit === DISTANCE_UNIT_MILE ? value : kmToMi(value);
}
